import { ReactNode } from 'react'
import Image from 'next/image'
import { PlatformThemeId } from '@reward-platform/shared-schemas'

import { getPublicAssetSrc } from '~/utils/assets'

import styles from './ErrorPageWrapper.module.scss'

type ErrorMessageWrapperProps = {
  themeId: PlatformThemeId
  children: ReactNode
  title?: string | ReactNode
}

export const ErrorPageWrapper = ({ children, title, themeId }: ErrorMessageWrapperProps) => {
  const isAviosTheme = themeId === 'avios'

  const backgroundSrc = isAviosTheme && getPublicAssetSrc('/assets/avios-bg-plectrum.svg')

  return (
    <div className={styles.container}>
      {title ? <h1 className={styles.title}>{title}</h1> : null}
      <div className={styles.content}>{children}</div>
      {backgroundSrc ? (
        <div className={styles.imageBackground}>
          <Image src={backgroundSrc} alt="error page background image" width={2000} height={2000} />
        </div>
      ) : null}
    </div>
  )
}
